import { useCallback } from 'react';
import {
  KoForm,
  KoFormBuilder,
  KoSelect,
  KoInput,
  KoTextArea
} from 'packages';
import styles from './crud.module.scss';

function PRCrud({ form, handleFinish, initialValues, reviewerOptions = [], ticketOptions = [], branchOptions = [] }) {
  const handleSubmit = useCallback((values) => {
    handleFinish(values);
  }, [handleFinish]);

  const TicketWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      showSearch
      placeholder='Search Kwapio ticket (e.g. KWP-884)'
      options={ticketOptions}
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
    />
  );

  const FromBranchWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      showSearch
      placeholder='feature/kwp-884-payment-gateway'
      options={branchOptions}
      style={{ fontFamily: 'var(--font-family-mono, monospace)' }}
    />
  );

  const IntoBranchWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      showSearch
      placeholder='release/v4.2.0'
      options={branchOptions}
      style={{ fontFamily: 'var(--font-family-mono, monospace)' }}
    />
  );

  const ReviewersWidget = ({ value, onChange }) => (
    <KoSelect
      mode='multiple'
      value={value}
      onChange={(v) => onChange(v)}
      showSearch
      placeholder='Assign lead reviewers'
      options={reviewerOptions}
    />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'title',
        label: 'PR Title',
        colSpan: 4,
        widget: KoInput,
        widgetProps: { placeholder: 'feat: describe your change clearly' }
      },
      {
        key: 'ticketId',
        label: 'Kwapio Ticket (required)',
        colSpan: 4,
        widget: TicketWidget,
        forwardRef: true,
        required: true,
        rules: [{ required: true, message: 'Every PR must reference a Kwapio ticket' }]
      },
      {
        key: 'fromBranch',
        label: 'From Branch',
        colSpan: 2,
        widget: FromBranchWidget,
        forwardRef: true
      },
      {
        key: 'intoBranch',
        label: 'Into Branch',
        colSpan: 2,
        widget: IntoBranchWidget,
        forwardRef: true
      },
      {
        key: 'reviewers',
        label: 'Reviewers (Leads)',
        colSpan: 4,
        widget: ReviewersWidget,
        forwardRef: true
      },
      {
        key: 'riskNote',
        label: 'Risk Impact Note',
        colSpan: 4,
        widget: KoInput,
        widgetProps: { placeholder: 'Describe any risk or impact of this change' }
      },
      {
        key: 'migrationNote',
        label: 'Migration Note',
        colSpan: 2,
        widget: KoInput,
        widgetProps: { placeholder: 'DB/schema migration details (if any)' }
      },
      {
        key: 'featureFlagRef',
        label: 'Feature Flag Reference',
        colSpan: 2,
        widget: KoInput,
        widgetProps: { placeholder: 'Flag name (if applicable)' }
      },
      {
        key: 'description',
        label: 'Description',
        colSpan: 4,
        widget: KoTextArea,
        widgetProps: {
          placeholder: 'What does this PR do? Any migration steps or notes for reviewers?',
          rows: 3
        }
      }
    ]
  };

  return (
    <div className={styles.wrapper}>
      <KoForm
        form={form}
        layout='vertical'
        onFinish={handleSubmit}
        onSubmit={handleSubmit}
      >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}

export default PRCrud;
